import script from "./UtmPage.vue?vue&type=script&setup=true&lang=js"
export * from "./UtmPage.vue?vue&type=script&setup=true&lang=js"

import "./UtmPage.vue?vue&type=style&index=0&id=4bd1e593&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bd1e593"]])

export default __exports__